//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import TableCellObject from '../../components/Table/TableCellObject.vue'
import TableCellExpand from '../../components/Table/TableCellExpand.vue'
import { formatTime, ALARM_SEVERITIES_CONFIG } from '../../components/helpers.js'

export default {
  components: {
    TableCellObject,
    TableCellExpand
  },
  props: {
    bodyProps: {
      type: Object,
      default: null
    },
    col: {
      type: Object,
      default: null
    },
    grid: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      formatTime: formatTime
    }
  },
  computed: {
    ...mapGetters({
      taskStatesColors: 'getTaskStatesColors',
      requestTypesColors: 'getRequestTypesColors',
      requestTypesTextColors: 'getRequestTypesTextColors',
      reportStateColors: 'getReportStateColors',
      reportStateTextColors: 'getReportStateTextColors'
    })
  },
  methods: {
    getTdStyle: function (col, row) {
      if (col.name === 'totalPriority') {
        if (row.totalPriority >= 14) {
          return this.getColoredTdStyle('red', 'white')
        }
      } else if (col.name === 'reinforcements') {
        return 'white-space: pre !important;'
      } else if (col.name === 'type') {
        return this.getColoredTdStyle(this.requestTypesColors[row.typeKey], this.requestTypesTextColors[row.typeKey])
      } else if (col.name === 'bpStateName') {
        if (this.taskStatesColors[row.bpStateId] === '#0000FF' || this.taskStatesColors[row.bpStateId] === '#000000' || this.taskStatesColors[row.bpStateId] === '#FF0000') {
          return this.getColoredTdStyle(this.taskStatesColors[row.bpStateId], 'white')
        } else {
          return this.getColoredTdStyle(this.taskStatesColors[row.bpStateId], 'black')
        }
      } else if (col.name === 'origin') {
        if (row.origin === 'external') {
          return this.getColoredTdStyle('#bbdefb', 'black')
        } else if (row.origin === 'internal') {
          return this.getColoredTdStyle('#eceff1', 'black')
        }
      } else if (col.name === 'reportBPStateName' && row.reportBPStateId != null) {
        return this.getColoredTdStyle(this.reportStateColors[row.reportBPStateId], this.reportStateTextColors[row.reportBPStateId])
      } else if (col.name === 'closeConditionTime' && row.closeConditionTime && row.activeByState) {
        if (row.closeConditionPriority === 'urgent') {
          return this.getColoredTdStyle('red', 'white')
        } else if (row.closeConditionPriority === 'high') {
          return this.getColoredTdStyle('orange', 'black')
        } else {
          return this.getColoredTdStyle('green', 'white')
        }
      } else if (col.name === 'alarms' && row.alarmSeverity != null) {
        return 'white-space: pre-line !important; text-align: left !important; font-weight: 500 !important;'
      }
    },
    getAlarmConfig: function (severityKey) {
      return ALARM_SEVERITIES_CONFIG[severityKey] || {}
    },
    getColoredTdStyle: function (bgColor, color, fontWeight = 1000) {
      if (bgColor == null) {
        bgColor = 'white'
        color = 'black'
      }
      let styles = `font-weight: ${fontWeight} !important;
          background-color: ${bgColor} !important;
          color: ${color} !important;`
      if (this.grid) {
        styles += ' padding: 2px 4px;'
      } else {
        styles += ' border-bottom: solid #e0e0e0 1px;'
      }

      return styles
    },
    canOpenObjectCard: function (row) {
      return typeof this.$d_getUrlObjectCard === 'function' && this.getObjectCardUrl(row) != null
    },
    getObjectCardUrl: function (row) {
      if (typeof this.$d_getUrlObjectCard !== 'function' || row == null) {
        return null
      }
      return this.$d_getUrlObjectCard(row.objectId, row.objectTypeKey)
    },
    getAddressUrlInYandexMaps: function (location) {
      if (!this.$d || typeof this.$d.getYandexMapsLocationUrl !== 'function') {
        return null
      }
      return this.$d.getYandexMapsLocationUrl(location)
    }
  }
}

